import { LegendComponentType } from '..'
import CheckboxComponent, { CheckboxProps } from './CheckboxComponent'

export const componentMap: Record<LegendComponentType, any> = {
  checkbox: CheckboxComponent
}

export type { CheckboxProps }

export { CheckboxComponent }
